module.exports = __webpack_public_path__ + "static/media/banner.fae92c24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner.jpg
// module id = 1625
// module chunks = 0